<template>
  <v-toolbar
    color="brand-beige"
    elevation="0"
    style="position: fixed; width: 100%; z-index: 1;"
  >
    <v-container
      fluid
      ma-0
      pa-0
    >
      <v-row no-gutters>
        <v-col
          cols="12"
          lg="10"
          offset-lg="1"
        >
          <div class="d-flex">
            <v-btn
              v-if="TagInfo"
              class="pa-0 brand-green-dark--text"
              color="transparent"
              depressed
              height="48"
              large
              style="min-width: 25px;"
              @click="onSelectTagClick()"
            >
              <v-avatar
                :class="getContrastColor(TagInfo.Color, 168) === 'black' ? 'black--text' : 'white--text'"
                :color="TagInfo.Color"
                class="ml-1"
                size="40"
                style="border: var(--v-brand-green-dark-base) solid 1px;"
              >
                <v-icon v-if="!TagInfo.LabelOnly">
                  {{ TagInfo.Icon }}
                </v-icon>
              </v-avatar>

              <span class="brand-text-title mx-2 hidden-xs-only">
                {{ getTranslatedField(TagInfo, 'Label') }}
              </span>

              <v-icon>
                mdi-chevron-down
              </v-icon>
            </v-btn>

            <v-tabs
              v-if="TagMenu"
              v-model="selectedTab"
              background-color="transparent"
              class="rounded"
              color="brand-primary"
              hide-slider
              light
              style="width: 0"
            >
              <template v-for="(store, idx) in TagMenuStores">
                <v-tab
                  :key="`store-${store.StoreId}-${idx}`"
                  :tab-value="`tab-${getTranslatedField(getStoreById(store.StoreId), 'Slug')}`"
                  active-class="brand-primary brand-green-dark--text"
                  class="v-btn--outlined brand-green--text px-4 mx-2 pl-0 brand-text-title"
                  @click="onStoreClick(store)"
                >
                  <v-avatar
                    class="rounded mr-2"
                    size="46"
                    tile
                  >
                    <v-img :src="getStoreById(store.StoreId).Logo" />
                  </v-avatar>

                  {{ getTranslatedField(getStoreById(store.StoreId)) }}
                </v-tab>
              </template>
            </v-tabs>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-toolbar>
</template>

<script>
import TagCatalogToolbarMixin from '@/theme/default/components/tag/TagCatalogToolbar.js'

export default {
  name  : 'TagCatalogToolbar',
  mixins: [TagCatalogToolbarMixin]
}
</script>

<style scoped src="@/theme/default/components/tag/TagCatalogToolbar.css"></style>

<style scoped>
:deep(.v-slide-group__next), :deep(.v-slide-group__prev) {
  flex: 0 1 32px !important;
  min-width: 32px !important;
}

:deep(.v-slide-group__next--disabled), :deep(.v-slide-group__prev--disabled) {
  flex: 0 1 0 !important;
  min-width: 0 !important;
}
</style>
